'use client'

import React from 'react'

const QUERY = '(min-width: 1024px)'

function subscribe(onChange: () => void): () => void {
	const mq = window.matchMedia(QUERY)
	mq.addEventListener('change', onChange)
	return () => mq.removeEventListener('change', onChange)
}

function getSnapshot(): boolean {
	return window.matchMedia(QUERY).matches
}

function getServerSnapshot(): boolean {
	return false
}

/// Whether the viewport is desktop-class (≥1024px), as live state.
///
/// JS-gated rather than CSS-gated because the two layouts are different
/// component TREES (the phone app vs the trading workspace) — hiding one with
/// CSS would still mount its charts, subscriptions and swap panel.
///
/// `useSyncExternalStore`, not a `useState(matchMedia)` initializer: the old
/// initializer assumed this subtree never renders on the server, but the dev
/// server DOES produce server HTML for it, and a desktop viewport then
/// hydrated phone-tree HTML against a desktop-tree first render — a mismatch
/// that killed the whole subtree in dev (workspace.tsx:31). With an external
/// store, hydration renders the server snapshot (phone) everywhere and React
/// re-renders with the real width immediately after — one corrective commit
/// on desktop instead of a crash, and identical behavior in dev and prod.
export default function useIsDesktop(): boolean {
	return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
